import { render, staticRenderFns } from "./ClauseDialog.vue?vue&type=template&id=a2807ddc&scoped=true&"
import script from "./ClauseDialog.vue?vue&type=script&lang=js&"
export * from "./ClauseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClauseDialog.vue?vue&type=style&index=0&id=a2807ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2807ddc",
  null
  
)

export default component.exports